import React from 'react';
import ProfileImg from '../../assets/images/dummy.png';
import Logo from '../../assets/images/logo/logo.png'
const ResultUserDetail = (props) => {
const resultDetail = props.resultDetail !== undefined && props.resultDetail;
const detail =  props.detail !== undefined && props.detail;
    return (
        <>
        <div className='card p-3 mb-4'>
           <div className='row'>
            <div className='col-md-3'>
            <img src={ProfileImg} alt="Profile" className="rounded-circle pdf-profile-img" />
            {/* {detail.profile_picture !== undefined && detail.profile_picture ?<img src={`${process.env.REACT_APP_API_URL}/public/uploads/profile_picture/${detail.profile_picture}`}  alt="Profile" className="img-fluid pdf-profile-img" />
                            :<img src={ProfileImg} alt="Profile" className="rounded-circle pdf-profile-img" />} */}
            </div>

            <div className='col-md-6'>
                <div className='pdf_userDetail_contain mt-3'>
                    <h4>Name : {detail.name}</h4>
                    <h5>Form Number : {detail.form_num}</h5>
                    <h5>Class : &nbsp;
                        
                         {detail!==undefined&& detail.class == 'VI' && 'V'}
                         {detail!==undefined&& detail.class == 'VII' && 'VI'}
                         {detail!==undefined&& detail.class == 'VIII' && 'VII'}
                         {detail!==undefined&& detail.class == 'IX' && 'VIII'}
                         {detail!==undefined&& detail.class == 'X' && 'IX'}
                         {detail!==undefined&& detail.class == 'XI' && 'X'}
                         {detail!==undefined&& detail.class == 'XI JEE' && 'X'}
                         {detail!==undefined&& detail.class == 'XI NEET' && 'X'}
                         {detail!==undefined&& detail.class == 'XII' && 'XI'}
                         {detail!==undefined&& detail.class == 'XIII' && 'XII'}
                         
                         </h5>
                    <h5>country : {detail.country}</h5>
                    <h5>{detail.email}</h5>
                </div>
            </div>

            <div className='col-md-3'>
                <h3 className='text-primary fw-bold'>2023-24</h3>

                <h6 className='mt-3 mb-3'>Presented By</h6>
                <img src={Logo} alt="Allen Logo" className='img-fluid' style={{width:160}} />
            </div>

           </div>
            
        </div>
        </>
    )
}

export default ResultUserDetail